<div class="gallery-container">
  <ngx-gallery [options]="galleryOptions" [images]="images"  class="ngx-gallery"></ngx-gallery>
</div>
